import { useNavigate } from "@tanstack/react-router";

import { trpc } from "@blis/trpc/react";

import { toast } from "@/components/ui/toast";
import { AuthProviderForm } from "../components/auth/AuthProviderForm";
import { Section } from "../components/Section";

export function NewProviderPage() {
  const navigate = useNavigate();

  const create = trpc.admin.auth.create.useMutation({
    onSuccess() {
      navigate({ to: "/admin/auth" });
      toast.success("Auth provider created successfully");
    },
    onError(err) {
      toast.error("Error creating auth provider", {
        description: err.message,
      });
    },
  });

  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>New provider</Section.Title>
      <AuthProviderForm
        onSubmit={async (input) => {
          await create.mutateAsync(input);
        }}
      />
    </div>
  );
}
